import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  nextTick,
  onBeforeMount,
  onMounted,
  onBeforeUnmount,
  ref
} from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import LicenseNameInput from '@/components/format-edit/LicenseNameInput.vue'

type HistoryItem = {
  year?: number | string
  month?: number | string
  description?: string
  uuid?: string
}

type ElFormLike = {
  validate: () => Promise<unknown>
}

type ElInputLike = {
  resizeTextarea?: () => void
  $el?: { offsetHeight?: number }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryItem',
  props: {
    item: null,
    index: null,
    length: null,
    descriptionPlaceholder: null,
    descriptionMaxLength: null,
    minYear: null,
    maxYear: null,
    suggestLicense: { type: Boolean }
  },
  emits: ["add-history-item", "delete-history-item", "move-history-item"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'add-history-item', index: number, item?: HistoryItem): void
  (e: 'delete-history-item', index: number): void
  (e: 'move-history-item', params: { index: number; to: string }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  item: HistoryItem
  index: number
  length: number
  descriptionPlaceholder?: string
  descriptionMaxLength?: number
  minYear?: number | string
  maxYear?: number | string
  /** 免許・資格欄のとき、入力中に正式名称の候補を出す */
  suggestLicense?: boolean
};





const { formLib } = useHostServices()
const historyItemForm = ref<ElFormLike | null>(null)
const desc = ref<ElInputLike | null>(null)
const errors = ref<string[]>([])

const editableItem = computed(() => props.item)
const computedMinYear = computed(() =>
  props.minYear ? Number(props.minYear) : 1900
)
const computedMaxYear = computed(() =>
  props.maxYear ? Number(props.maxYear) : new Date().getFullYear() + 3
)

function lengthRule(getMax: () => number, message: string) {
  return [
    {
      validator: (
        _rule: unknown,
        value: string | undefined,
        callback: (err?: Error) => void
      ) => {
        if (formLib.charCount(value) > getMax()) {
          callback(new Error('Please input digits'))
        } else callback()
      },
      message,
      trigger: ['change', 'blur']
    }
  ]
}

const rules = {
  year: lengthRule(() => 6, '年が長すぎます'),
  month: lengthRule(() => 4, '月が長すぎます'),
  description: lengthRule(
    () => props.descriptionMaxLength || 0,
    '一行におさまる文字数をオーバーしています。文章を短くするか、行を ＋ で追加して入力してください。'
  )
}

function handleCommand(command: string) {
  if (command === 'addAbove') emit('add-history-item', props.index)
  else if (command === 'addBelow') emit('add-history-item', props.index + 1)
  else if (command === 'delete') emit('delete-history-item', props.index)
  else if (command === 'duplicate') {
    emit('add-history-item', props.index, props.item)
  } else if (command === 'moveUp') {
    emit('move-history-item', { index: props.index, to: 'up' })
  } else if (command === 'moveDown') {
    emit('move-history-item', { index: props.index, to: 'down' })
  }
}

function resizeDesc() {
  nextTick(() => {
    const target = desc.value
    // 表示されているか確認する
    if (target && typeof target.resizeTextarea === 'function') {
      if (target.$el && target.$el.offsetHeight) target.resizeTextarea()
    }
  })
}

onBeforeMount(() => {
  nextTick(() => {
    // 初回読み込み時にバリデーションを動かす
    historyItemForm.value?.validate().catch((e) => console.error(e))
  })
})

// 表示されていない要素だとリサイズが走らないので、カード変更のタイミングで実行する
onMounted(() => {
  emitter.on('card-changed', resizeDesc)
})

onBeforeUnmount(() => {
  emitter.off('card-changed', resizeDesc)
})

return { __sfc: true,props, emit, formLib, historyItemForm, desc, errors, editableItem, computedMinYear, computedMaxYear, lengthRule, rules, handleCommand, resizeDesc, emitter, LicenseNameInput }
}

})